endTime<template>
  <div class="media-list">
    <!-- 导出空位表弹窗 -->
    <emptyPopModule @newHandleOk="emptyOk"
                    :visible="emptyPop"
                    :title="'导出空位'"
                    @afterClose="offEmptyPop">
    </emptyPopModule>
    <breadcrumb main-name="广告订单"
                :breadcrumbList="breadcrumbList">
    </breadcrumb>
    <div class="create-plan">
      <a-button @click="emptyPop = true"
                :type="emptyPop ? 'primary' : ''"
                style="margin-right: 10px"
                v-if="
          userInfo.userType == 2 ||
          userInfo.userType == 4 ||
          userInfo.userType === 5 ||
          userInfo.userType === 7
        ">导出空位</a-button>
      <a-button class="save-btn"
                @click="showDraftsModal"
                v-if="
          userInfo.userType == 2 ||
          userInfo.userType == 4 ||
          userInfo.userType === 5 ||
          userInfo.userType === 7
        ">草稿箱</a-button>
      <a-button type="primary"
                @click="createPlan"
                v-if="
          userInfo.userType == 2 ||
          userInfo.userType == 4 ||
          userInfo.userType === 5 ||
          userInfo.userType === 7
        "
                style="width: 88px">新建订单
      </a-button>
    </div>

    <div style="padding: 24px">
      <div class="select-box">
        <div id="components-form-demo-advanced-search">
          <a-row :gutter="24">
            <a-col :span="8">
              <span class="form-label">订单名称：</span>
              <a-input v-model="planForm.planName"
                       placeholder="请输入计划名称" />
            </a-col>
            <a-col :span="8">
              <span class="form-label">广告主：</span>
              <a-input v-model="planForm.advertiserName"
                       placeholder="请输入广告主名称" />
            </a-col>
            <a-col v-show="foldForm"
                   :span="8">
              <span class="form-label">开始时间：</span>
              <a-range-picker :value="planForm.startTime"
                              @change="changeTime"
                              :placeholder="[]" />
            </a-col>
            <a-col v-show="foldForm"
                   :span="8">
              <span class="form-label">渠道方：</span>
              <a-select placeholder="请选择创建渠道"
                        style="width: 100%"
                        optionFilterProp="children"
                        v-model="planForm.channelId"
                        :allowClear="true">
                <a-select-option v-for="(item, index) in channelList"
                                 :key="index"
                                 :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col v-show="foldForm"
                   :span="8">
              <span class="form-label">结算方式：</span>
              <a-select placeholder="请选择结算方式"
                        optionFilterProp="children"
                        style="width: 100%"
                        v-model="planForm.settlementType"
                        :allowClear="true">
                <a-select-option v-for="(item, index) in chargeType"
                                 :key="index"
                                 :value="item.value">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="8"
                   style="text-align: right">
              <a-button type="primary"
                        html-type="submit"
                        @click="handleSearch">
                查询
              </a-button>
              <a-button :style="{ marginLeft: '8px' }"
                        @click="handleReset">
                重置
              </a-button>
              <div class="fold-btn"
                   @click="foldClick">
                <span style="margin: 0 4px 0 12px">{{
                  foldForm ? '收起' : '展开'
                }}</span>
                <a-icon type="down"
                        :class="['rotate-icon', { 'rotate-up': foldForm }]" />
              </div>
            </a-col>

            <a-col :span="24">
              <span class="form-label">订单状态：</span>
              <a-button v-for="(item, index) in orderStatusList"
                        :key="index"
                        class="filter-btn"
                        :class="[item.class]"
                        @click="filterOrderStatus(item, 'status')">{{
                  `${item.key}${
                    item.class == 'filter-btn-primary'
                      ? '(' + item.count + ')'
                      : ''
                  }`
                }}</a-button>
            </a-col>
            <a-col :span="24">
              <span class="form-label">素材状态：</span>
              <a-button v-for="(item, index) in materielStatusList"
                        :key="index"
                        class="filter-btn"
                        :class="[item.class]"
                        @click="filterOrderStatus(item, 'materialStatus')">{{ item.key }}</a-button>
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="table-wrap">
        <a-table :columns="columns"
                 :dataSource="adList"
                 :pagination="false"
                 :scroll="{ x: tableX }">
          <template slot="orderStatus"
                    slot-scope="row">
            <span v-if="row.status == -3">
              <a-badge status="error" />已拒绝
            </span>
            <span v-else-if="row.status == -2">
              <a-badge status="warning" />待确认
            </span>
            <span v-else-if="row.status == 2">
              <a-badge status="processing" />投放中
            </span>
            <span v-else-if="row.status == 3">
              <a-badge status="success" />待投放
            </span>
            <!-- <span v-else-if="row.status == 4"><a-badge status="warning"/>备案未通过</span> -->
            <span v-else-if="row.status == 6">
              <a-badge status="default" />已完成
            </span>
            <span v-else-if="row.status == 8">
              <a-badge status="default" />已过期
            </span>
            <span v-else-if="row.status == 9">
              <a-badge status="default" />已取消
            </span>
            <span v-else-if="row.status == 10">
              <a-badge status="default" />已终止
            </span>
            <span v-else>
              <a-badge status="default" />{{ row.statusName }}
            </span>
          </template>
          <template slot="materialStatus"
                    slot-scope="row">
            <span v-if="row.materialStatus == -1">
              <a-badge status="error" />备案未通过
            </span>
            <span v-else-if="row.materialStatus === 0">
              <a-badge status="default" />无效
            </span>
            <span v-else-if="row.materialStatus == 1">
              <a-badge status="success" />备案通过
            </span>
            <span v-else-if="row.materialStatus == 2">
              <a-badge status="warning" />待备案
            </span>
            <!-- <span v-else-if="row.materialStatus == 3"><a-badge status="error"/>无效</span> -->
            <span v-else-if="row.materialStatus == -999">
              <a-badge status="error" />删除
            </span>
            <span v-else>{{ row.materialStatusName }}</span>
          </template>
          <template slot="action"
                    slot-scope="row">
            <a-dropdown placement="bottomCenter">
              <a class="ant-dropdown-link"
                 href="javascript:;"
                 :disabled="
                  (row.status == 0 &&
                    (userInfo.userType == 1 || userInfo.userType === 5)) ||
                  (userInfo.userId != row.createUserId && row.status == 0)
                ">
                操作
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay"
                      @click="handleRow($event, row)">
                <a-menu-item key="showMaterial"
                             v-if="
                    (row.status == 1 && userInfo.userType != 1) ||
                    (row.status != 1 && row.status != 0)
                  ">
                  查看物料
                </a-menu-item>
                <a-menu-item key="goDetail"> 订单详情 </a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
        </a-table>
        <div class="page-wrap">
          <a-pagination :pageSizeOptions="pageSizeOptions"
                        :total="total"
                        showSizeChanger
                        showQuickJumper
                        :pageSize="pageSize"
                        v-model="current"
                        @showSizeChange="onShowSizeChange"
                        @change="changePage">
          </a-pagination>
        </div>
      </div>
    </div>
    <!--填写备案意见-->
    <a-modal :title="auditTitle"
             v-model="auditModal"
             @ok="audit"
             okText="确认"
             cancelText="取消"
             :afterClose="clearValue">
      <a-textarea v-model="auditText"
                  :autosize="{ minRows: 4, maxRows: 6 }" />

      <template slot="footer">
        <a-button @click="audit()"
                  :loading="btnLoading"
                  type="primary">确定</a-button>
        <a-button @click="auditModal = false"
                  :loading="btnLoading">取消</a-button>
      </template>
    </a-modal>
    <a-modal title="查看物料"
             v-model="uploadMaterialModal"
             :footer="null"
             width="977px"
             destroyOnClose>
      <div class="material_warp">
        <material-frames :isEdit="false"
                         :isDuration="materialData.isDuration"
                         :beginTime="materialData.beginTime"
                         :endTime="materialData.endTime"
                         :planId="materialData.planId"
                         :materialSize="materialData.materialSize" />
      </div>
    </a-modal>
    <!--查看大图-->
    <a-modal v-model="previewImgModal"
             :footer="null"
             width="40%">
      <div class="img-box">
        <img :src="previewUrl"
             alt=""
             style="width: 100%" />
      </div>
    </a-modal>
    <!--查看视频-->
    <a-modal v-model="previewVideoModal"
             :footer="null"
             @cancel="handleCancel"
             width="40%">
      <div class="video-box">
        <video ref="showMaterialVideo"
               :src="previewUrl"
               controls
               autoplay="autoplay"
               loop="loop"></video>
      </div>
    </a-modal>
    <drafts-modal :draftsVisible="draftsVisible"
                  ref="draftsModal" />
  </div>
</template>

<script>
import breadcrumb from '../common/Breadcrumb.vue'
import api from '../../commomFun/api.js'
import timeFormat from '../../commomFun/timeFormat'
import typeData from '../../commomFun/json/type.json'
import moment from 'moment'
import { config } from '../../utils/config'
import checkUpload from '../../commomFun/checkUploadFile'
import draftsModal from './draftsModal'
import emptyPopModule from '../common/new/newEmptyPop' //弹窗对话
import { mapState, mapMutations, mapActions } from 'vuex'
import materialFrames from './materialFrames/index.vue' //查看物料组件
export default {
  name: 'channelAdPlan',
  components: {
    breadcrumb,
    draftsModal,
    emptyPopModule,
    materialFrames,
  },
  inject: ['reload'],
  data() {
    return {
      foldForm: false,
      emptyPop: false, //导出空位的弹窗是否显隐
      hasCache: false, // 判断是否有缓存
      draftsVisible: false,
      tableX: 1770,
      userInfo: '',
      btnLoading: false,
      // 面包屑
      breadcrumbList: [
        {
          name: '投放管理',
          path: '',
        },
        {
          name: '广告订单',
          path: '/channelAdPlan',
        },
      ],
      planForm: {
        planName: '',
        advertiserName: '',
        startTime: [],
        channelId: undefined,
        settlementType: '',
        status: [-2, 2, 3, 7],
        materialStatus: [0, 1, -1, 2],
      },
      start: '',
      end: '',
      dateFormat: 'YYYY-MM-DD',
      columns: [
        {
          title: '渠道方',
          key: 'channelName',
          dataIndex: 'channelName',
          align: 'left',
          width: 80,
        },
        {
          title: '订单名称',
          key: 'planName',
          dataIndex: 'planName',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: '广告主',
          key: 'advertiserName',
          dataIndex: 'advertiserName',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: '结算方式',
          key: 'settlementName',
          dataIndex: 'settlementName',
          align: 'center',
          width: 80,
        },
        {
          title: '开始日期',
          key: 'startTime',
          dataIndex: 'startTime',
          align: 'center',
          width: 120,
        },
        {
          title: '结束日期',
          key: 'endTime',
          dataIndex: 'endTime',
          align: 'center',
          width: 120,
        },
        {
          title: '广告时长',
          key: 'playDuration',
          dataIndex: 'playDuration',
          customRender: (text, record, index) =>
            (record.playDuration || '--') + '秒',
          align: 'center',
          width: 80,
        },
        // {//盖哥说隐藏，把这个次数挪到成功率里边
        //   title: '播放次数',
        //   key: 'playCount',
        //   dataIndex: 'playCount',
        //   align: 'left',
        //   width: 100
        // },

        {
          title: '投放成功率',
          key: 'deliveryCompletionRate',
          dataIndex: 'deliveryCompletionRate',
          align: 'center',
          ellipsis: true,
          width: 130,
        },
        {
          title: '订单完成率',
          key: 'orderCompletionRate',
          dataIndex: 'orderCompletionRate',
          align: 'center',
          ellipsis: true,
          width: 130,
        },
        {
          title: '更新时间',
          key: 'updateTime',
          dataIndex: 'updateTime',
          align: 'center',
          width: 130,
        },
        {
          title: '订单状态',
          key: 'status',
          fixed: 'right',
          scopedSlots: { customRender: 'orderStatus' },
          align: 'left',
          width: 120,
        },
        {
          title: '素材状态',
          key: 'materialStatus',
          fixed: 'right',
          scopedSlots: { customRender: 'materialStatus' },
          align: 'left',
          width: 120,
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
          align: 'left',
          width: 100,
        },
      ],
      adList: [],
      pageSizeOptions: ['10', '20', '30', '40'],
      current: 1,
      pageSize: 10,
      playTimes: 0,
      total: 0,
      auditModal: false,
      auditType: '', //通过或不通过
      //上传物料
      header: {
        token: '',
        uid: '',
      },
      materialAuditModal: false,
      playDuration: 0,
      uploadInfo: {
        playForm: '全屏',
        playDuration: '5',
      },
      uploadMaterialModal: false,
      fullImgLoading: false,
      uploadMaterialImgUrl: config.uploadMaterialImgUrl,
      //视频、图片放大
      previewImgModal: false,
      previewVideoModal: false,
      previewUrl: '',
      auditText: '',
      auditTitle: '',
      currRow: '',
      chargeType: [
        {
          label: '不限',
          value: '',
        },
        {
          label: 'CPM',
          value: '1',
        },
        {
          label: 'CPT',
          value: '2',
        },
      ],
      channelList: [],
      // 当前操作计划的版本号
      version: '',
      // 所有设备类型信息
      modelTypeInfos: [],
      // 上传物料
      modelMaterials: [],
      // 当前选中的机型
      activeModelType: 7,
      activeIndex: 0,
      // 当前上传物料的机型下标（解决还在上传中切换了机型导致物料关联错误）
      uploadingModelIndex: 0,
      // 当前选择的机型的素材
      activeModelMaterial: {
        materialSize: '',
        adSize: '',
        modelID: '',
        model: '',
        isDuration: 10,
      },
      planId: '',
      uploadMLoading: false,
      orderStatusList: [
        { key: '待确认', val: -2, class: 'filter-btn-primary', count: 0 },
        { key: '待投放', val: 3, class: 'filter-btn-primary', count: 0 },
        { key: '投放中', val: 2, class: 'filter-btn-primary', count: 0 },
        { key: '已完成', val: 6, class: 'filter-btn-default', count: 0 },
        { key: '已过期', val: 8, class: 'filter-btn-default', count: 0 },
        { key: '已取消', val: 9, class: 'filter-btn-default', count: 0 },
        { key: '已终止', val: 10, class: 'filter-btn-default', count: 0 },
        { key: '已暂停', val: 7, class: 'filter-btn-primary', count: 0 },
        { key: '已拒绝', val: -3, class: 'filter-btn-default', count: 0 },
      ],
      materielStatusList: [
        { key: '待备案', val: 2, class: 'filter-btn-primary' },
        { key: '备案通过', val: 1, class: 'filter-btn-primary' },
        { key: '备案不通过', val: -1, class: 'filter-btn-primary' },
        { key: '无效', val: 0, class: 'filter-btn-primary' },
        // {key: '无效', val: 3, class: 'filter-btn-default'}
      ],
      filterTimeout: null,
      materialData: {
        isDuration: 0,
        beginTime: '',
        endTime: '',
        planId: '',
        materialSize: '',
      }, //当前查看物料
    }
  },
  mounted() {
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    this.header.token = this.userInfo.token
    this.header.uid = this.userInfo.userId
    // 获取设备信息
    this.getDeviceModel()
    // 获取渠道列表
    this.getChannelList()
    this.getAdPlanList()
    this.getCountPlan()
  },
  methods: {
    ...mapMutations(['resetData', 'setStorageFramesData']),
    ...mapActions(['getMaterialList']),
    moment,
    // 表单搜索展开与收起
    foldClick() {
      this.foldForm = !this.foldForm
    },
    // 导出空位弹窗的确定
    emptyOk(val) {
      this.emptyPop = val
      console.log('确定的关闭')
    },
    // 导出空位关闭
    offEmptyPop(val) {
      this.emptyPop = val
    },
    // 根据订单状态筛选列表
    filterOrderStatus(item, flag) {
      item.class =
        item.class == 'filter-btn-primary'
          ? 'filter-btn-default'
          : 'filter-btn-primary'
      if (flag == 'materialStatus') {
        let tempArr = []
        this.materielStatusList.forEach((current) => {
          if (current.class === 'filter-btn-primary') {
            tempArr.push(current.val)
          }
        })
        this.planForm.materialStatus = tempArr
      } else if (flag == 'status') {
        let tempArr = []
        this.orderStatusList.forEach((current) => {
          if (current.class === 'filter-btn-primary') {
            tempArr.push(current.val)
          }
        })
        this.planForm.status = tempArr
      }
      clearTimeout(this.filterTimeout)
      this.filterTimeout = setTimeout(() => {
        this.current = 1
        this.getAdPlanList()
        this.getCountPlan()
      }, 800)
    },
    // 控制草稿箱modal
    showDraftsModal() {
      this.$refs.draftsModal.getListTaskByPage(1)
      this.draftsVisible = true
    },
    // 获取渠道列表
    getChannelList() {
      api.getApiSpecil('/platform/channel/list', {}).then((res) => {
        if (res.data.code === 200 && Array.isArray(res.data.data)) {
          this.channelList = res.data.data || []
        } else {
          this.$message.warning(res.data.msg || '渠道信息异常')
        }
      })
    },
    // 获取设备类型配置信息
    getDeviceModel() {
      api.getApi('/machine/deviceModel/all', {}).then((res) => {
        if (res.data.code === 200) {
          this.modelTypeInfos = res.data.data.map((item) => {
            return {
              modelID: item.deviceModel,
              model: item.deviceModelText,
              adSize:
                item.deviceModelAttributes[0].width +
                '*' +
                item.deviceModelAttributes[0].height,
              materialSize: {
                h: item.deviceModelAttributes[0].materialAttribute
                  ? item.deviceModelAttributes[0].materialAttribute[0].height
                  : '',
                w: item.deviceModelAttributes[0].materialAttribute
                  ? item.deviceModelAttributes[0].materialAttribute[0].width
                  : '',
              },
              checkboxModel: false,
            }
          })
        } else {
          this.$message.warning(res.data.msg || '设备信息异常')
        }
      })
    },
    //新建计划
    createPlan() {
      sessionStorage.setItem('edit', '')
      sessionStorage.setItem('planId', '')
      sessionStorage.removeItem('conditionList')
      sessionStorage.removeItem('formItem')
      sessionStorage.removeItem('planId')
      sessionStorage.removeItem('materialDetailsList')
      // sessionStorage.removeItem('selectedList')
      this.$localForage.removeItem('selectedList', ()=>{})
      sessionStorage.removeItem('areaDataListRow')
      sessionStorage.removeItem('selectedInfo')
      //清除本地多画面缓存
      sessionStorage.removeItem('framesData')
      // 清除vuex多画面数据 防止新建后再新建存在数据
      // this.resetData()
      sessionStorage.setItem('planSetType', 'create')
      sessionStorage.setItem('targetSetType', 'create')
      sessionStorage.setItem('materialSetType', 'create')
      sessionStorage.setItem('draftId', '')
      this.isCache()
    },
    isCache() {
      api.getApi_header('/draft/plan/hasCache', {}).then((res) => {
        const { data, code } = res
        if (data && code === 200) {
          this.getCache()
        } else {
          //重置vuex多画面数据，避免查看订单后新建订单存在vuex缓存影响创建
          this.resetData()
          this.$router.push('/channelPlanSet')
        }
      })
    },
    // getCache只在每次新建时拉取，页面刷新的时候会上传缓存
    // 刷新后页面的复原用的是本地缓存
    getCache() {
      api.getApi_header('/draft/plan/getCache', {}).then((res) => {
        const { data, code } = res
        if (code === 200) {
          this.step = data.step
          sessionStorage.setItem('step', data.step)
          sessionStorage.setItem('formItem', data.planInfo)
          this.seletStep(data)
        } else {
          this.$router.push('/channelPlanSet')
        }
      })
    },
    seletStep(data) {
      const { devInfo } = data
      let devInfoData = {}
      try {
        devInfoData = JSON.parse(devInfo)
      } catch {
        devInfoData = {}
      }
      Object.keys(devInfoData).forEach((key) => {
        try {
          if (key == 'selectedList') {
            this.$localForage.setItem('selectedList',devInfoData[key]);
          } else {
            const cachaeItem = JSON.parse(devInfoData[key])
            sessionStorage.setItem(key, JSON.stringify(cachaeItem))
          }
        } catch {
          sessionStorage.setItem(key, JSON.stringify(devInfoData[key]))
        }
      })
      //如果存在第三部的缓存数据，则设置。没有的话重置vuex
      let framesData = JSON.parse(window.sessionStorage.getItem('framesData'))
      if (framesData) {
        this.setStorageFramesData(framesData)
      } else {
        //重置vuex多画面数据，避免查看订单后新建订单存在vuex缓存影响创建
        this.resetData()
      }
      this.$router.push('/channelPlanSet')
    },
    //选择时间
    changeTime(data, dataString) {
      if (dataString[0] !== '') {
        let arr = []
        arr.push(moment(dataString[0], this.dateFormat))
        arr.push(moment(dataString[1], this.dateFormat))
        this.planForm.startTime = arr
      } else {
        this.planForm.startTime = []
      }
    },
    //查询
    handleSearch() {
      this.current = 1
      this.getAdPlanList()
      // 统计当前查询条件下的计划状态统计
      this.getCountPlan()
    },
    //重置
    handleReset() {
      this.planForm = {
        planName: '',
        advertiserName: '',
        startTime: [],
        channelId: undefined,
        settlementType: '',
        status: this.planForm.status || [],
        materialStatus: this.planForm.materialStatus || [],
      }
      this.getAdPlanList()
      this.getCountPlan()
    },
    changePage(page, pageSize) {
      this.current = page
      this.getAdPlanList()
    },
    onShowSizeChange(current, pageSize) {
      this.current = current
      this.pageSize = pageSize
      this.getAdPlanList()
    },
    //列表操作
    handleRow(key, row) {
      this.currRow = row
      let that = this
      let planId = row.planId
      if (key.key === 'showMaterial') {
        //查看物料
        this.getAdPlanDetail(row.planId)
      } else if (key.key === 'goDetail') {
        this.goPlanDetail(row)
      }
    },
    //获取计划详情
    async getAdPlanDetail(planId) {
      let { data, code } = await this.getMaterialList(planId)
      data = data[0]
      if (data && code == 200) {
        this.materialData = {
          isDuration: data.playDuration,
          beginTime: data.beginTime,
          endTime: data.endTime,
          planId: data.planId,
          materialSize: {
            w: 1080,
            h: 1540,
          }, //查看不能编辑随便传个尺寸
        }
        this.uploadMaterialModal = true
      } else {
        this.$message.warning(res.data.msg || '计划详情获取异常')
      }
    },
    //合并相同key值的数据
    mergeSameData(arr) {
      let hash = {}
      let i = 0
      let res = [] //结果数组
      arr.forEach(function (item) {
        var adSize = item.adSize
        if (hash[adSize]) {
          //有相同的id的对象,把regionDirections合并到第一个对象里
          res[hash[adSize] - 1].model = res[hash[adSize] - 1].model.concat([
            item.model,
          ])
          res[hash[adSize] - 1].modelID = res[hash[adSize] - 1].modelID.concat([
            item.modelID,
          ])
          res[hash[adSize] - 1].materialId = res[
            hash[adSize] - 1
          ].materialId.concat([item.materialId])
        } else {
          //没有相同的id
          hash[adSize] =
            ++i &&
            res.push({
              ...item,
              model: [item.model],
              modelID: [item.modelID],
              materialId: [item.materialId],
            })
        }
      })
      return res
    },
    //通过或不通过
    auditPlan(type) {
      if (type === 'y') {
        this.auditTitle = '请填写【通过】的备案意见'
      } else {
        this.auditTitle = '请填写【不通过】的备案意见'
      }
      this.auditModal = true
      this.auditType = type
      this.uploadMaterialModal = false
    },
    //填写备案意见-确定
    audit() {
      let that = this
      let opinion = this.auditText
      let row = this.currRow
      this.btnLoading = true
      let info = {
        planId: row.planId,
        reason: opinion,
        version: this.version,
      }
      if (this.auditType === 'y') {
        info.result = 1
      } else {
        info.result = 0
      }
      api.postApi('/adPlan/check/review', info).then((res) => {
        if (res.data.code !== 200) {
          that.$message.error(res.data.msg)
        } else {
          that.auditModal = false
          that.materialAuditModal = false
          that.btnLoading = false
          that.$message.success('操作成功')
          // this.reload()
          that.getAdPlanList()
        }
      })
    },
    //关闭审核弹框
    clearValue() {
      this.auditText = ''
    },
    // 放大关闭
    handleCancel() {
      this.previewVideoModal = false
      this.$refs.showMaterialVideo.pause()
    },
    //跳转详情
    goPlanDetail(row) {
      sessionStorage.setItem('planId', row.planId)
      const { href } = this.$router.resolve({
        path: '/channelAdPlanDetail',
      })
      window.open(href, '_blank')
    },
    //预览大图/视频
    previewMaterial(type, url) {
      this.previewUrl = url
      if (type == 1) {
        this.previewImgModal = true
      } else {
        this.previewVideoModal = true
        let timer = setTimeout(() => {
          let video = this.$refs.showMaterialVideo
          video.play()
          clearTimeout(timer)
        }, 200)
      }
    },
    // 统计计划状态
    getCountPlan() {
      let info = {}
      if (this.planForm.planName) {
        info.planName = this.planForm.planName
      }
      if (this.planForm.advertiserName) {
        info.advertiserName = this.planForm.advertiserName
      }
      if (this.planForm.startTime.length > 0) {
        info.beginDate = this.planForm.startTime[0]._i
        info.endDate = this.planForm.startTime[1]._i
      }
      if (this.planForm.settlementType) {
        info.settlementType = this.planForm.settlementType
      }
      if (this.planForm.channelId) {
        info.channelId = this.planForm.channelId
      }
      if (this.planForm.status.length > 0) {
        info.status = this.planForm.status
      }
      if (this.planForm.materialStatus.length > 0) {
        info.materialStatus = this.planForm.materialStatus
      }
      api.postApi('/adPlan/countPlan', info).then((res) => {
        if (
          res.data.code === 200 &&
          res.data.data &&
          Array.isArray(res.data.data)
        ) {
          let statusObj = {}
          res.data.data.forEach((statusItem) => {
            statusObj[statusItem.status] = statusItem.count || 0
          })
          this.orderStatusList.forEach((item) => {
            item.count = statusObj[item.val] || 0
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //获取计划列表
    getAdPlanList() {
      let info = {
        pageNum: this.current,
        pageSize: this.pageSize,
      }
      if (this.planForm.planName) {
        info.planName = this.planForm.planName
      }
      if (this.planForm.advertiserName) {
        info.advertiserName = this.planForm.advertiserName
      }
      if (this.planForm.startTime.length > 0) {
        info.beginDate = this.planForm.startTime[0]._i
        info.endDate = this.planForm.startTime[1]._i
      }
      if (this.planForm.settlementType) {
        info.settlementType = this.planForm.settlementType
      }
      if (this.planForm.channelId) {
        info.channelId = this.planForm.channelId
      }
      if (this.planForm.status.length > 0) {
        info.status = this.planForm.status
      }
      if (this.planForm.materialStatus.length > 0) {
        info.materialStatus = this.planForm.materialStatus
      }
      api.postApi('/adPlan/list', info).then((res) => {
        if (res.data.code === 200) {
          this.total = res.data.data.total
          res.data.data.list.forEach((item, index) => {
            item.key = index
            item.startTime = item.beginTime
              ? timeFormat.toDate(item.beginTime)
              : '--'
            item.endTime = item.endTime ? timeFormat.toDate(item.endTime) : '--'
            item.updateTime = item.updateTime
              ? timeFormat.toDate(item.updateTime)
              : '--'
            if (typeof item.deliveryCompletionRate == 'object') {
              //null得类型是个object
              item.deliveryCompletionRate = '--'
            }
            if (typeof item.orderCompletionRate == 'object') {
              item.orderCompletionRate = '--'
            }
            //如果订单在这三个状态之外直接显示--
            if (
              item.status == 2 ||
              item.status == 10 ||
              item.status == 6 ||
              item.status == 7
            ) {
              if (item.orderCompletionRate == '--') {
                item.orderCompletionRate = item.orderPlayCount || '--'
              } else {
                item.orderCompletionRate = `${item.orderCompletionRate}（${item.orderPlayCount}/${item.orderTotalCount}）`
              }
              if (item.deliveryCompletionRate == '--') {
                item.deliveryCompletionRate = item.pointPlayCount || '--'
              } else {
                item.deliveryCompletionRate = `${item.deliveryCompletionRate}（${item.pointPlayCount}/${item.pointTotalCount}）`
              }
            } else {
              item.orderCompletionRate = '--'
              item.deliveryCompletionRate = '--'
            }
          })
          this.adList = res.data.data.list
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 切换尺寸
    changeTags(item, index) {
      this.activeModelType = item.adSize
      this.activeIndex = index
      for (let key of this.modelMaterials) {
        if (key.adSize === item.adSize) {
          this.activeModelMaterial = JSON.parse(JSON.stringify(key))
          break
        }
      }
    },
    // 上传前的校验
    beforeUploadFun(file) {
      return checkUpload.beforeFile(
        file,
        this.activeModelMaterial.materialSize.w,
        this.activeModelMaterial.materialSize.h,
        this.activeModelMaterial.isDuration
      )
    },
    // 时常切换
    changeDuration(String) {
      for (let key of this.modelMaterials) {
        if (key.adSize === this.activeModelMaterial.adSize) {
          key.isDuration = this.activeModelMaterial.isDuration
          if (this.activeModelMaterial.fileType === 3 || String === 'del') {
            // 点击时长选项,如果上传的素材是视频则要清空重传
            this.clostFullImageUpdate()
          }
          break
        }
      }
    },
    // 删除图片、视频
    clostFullImageUpdate() {
      this.activeModelMaterial.fullImageUrl = ''
      this.activeModelMaterial.fullImageName = ''
      this.activeModelMaterial.fullImageFileId = ''
      this.activeModelMaterial.fullImageFileMd5 = ''
      this.activeModelMaterial.fullImageFileUrl = ''
      this.activeModelMaterial.fileCryptUrl = ''
    },
    // 上传文件改变时的状态
    handleChangeFullScreen(info) {
      if (info.file.status === 'uploading') {
        this.fullImgLoading = true
        return
      }
      if (info.file.status === 'done') {
        this.fullImgLoading = false
        if (info.file.response.code === 200) {
          let data = info.file.response.data
          let materialInfo = data.materialInfo
          let activeModelMaterial =
            this.modelMaterials[this.uploadingModelIndex] //this.activeModelMaterial
          if (
            data.fileType === 3 &&
            (materialInfo.lengthInTime < activeModelMaterial.isDuration ||
              materialInfo.lengthInTime > activeModelMaterial.isDuration + 1)
          ) {
            this.$message.error('上传失败！请上传相应播放时长的视频！')
            return
          }
          activeModelMaterial.fileType = data.fileType
          activeModelMaterial.fullImageUrl = data.fileUrl
          activeModelMaterial.fullImageName = data.fileName
          activeModelMaterial.fullImageFileId = data.fileId
          activeModelMaterial.fullImageFileMd5 = data.fileMd5
          activeModelMaterial.fullImageFileUrl = data.fileUrl
          activeModelMaterial.adSpace = 3 // 1为上半屏，2为下半屏，3为下半屏+上半屏（也就是全屏）
          activeModelMaterial.fileId = data.fileId
          activeModelMaterial.fileCryptUrl = data.fileCryptUrl
          if (this.activeIndex === this.uploadingModelIndex) {
            this.activeModelMaterial = JSON.parse(
              JSON.stringify(activeModelMaterial)
            )
          }
        } else {
          this.$message.warning(info.file.response.msg || '素材上传异常')
        }
      }
    },
    // 创建广告计划(第二步 保存素材信息和创建物料)
    uploadMaterial() {
      this.uploadMLoading = true
      let details = []
      let temp = []
      for (let data of this.modelMaterials) {
        for (let i = 0; i < data.modelID.length; i++) {
          let obj = {
            ...data,
            model: data.model[i],
            modelID: data.modelID[i],
            materialId: data.materialId[i],
          }
          temp.push(obj)
        }
      }
      for (let key of temp) {
        let materialDetailsList = []
        if (key.fullImageFileId) {
          materialDetailsList = [
            {
              fileType: key.fileType, // 文件类型1为图片海报 2声音 3视频
              fileId: key.fileId,
              fileName: key.fullImageName,
              fileMd5: key.fullImageFileMd5,
              fileUrl: key.fullImageFileUrl,
              adSpace: key.adSpace, // 1为上半屏，2为下半屏，3为下半屏+上半屏（也就是全屏）
              planId: this.planId,
              fileCryptUrl: key.fileCryptUrl,
            },
          ]
        }
        details.push({
          materialId: key.materialId,
          planId: this.planId,
          playType: 1, // 全屏
          playDuration: key.isDuration,
          deviceModel: key.modelID,
          deviceModelText: key.model,
          beginTime: key.beginTime,
          endTime: key.endTime,
          playTimes: this.playTimes,
          materialDetailsList: materialDetailsList,
        })
      }
      if (details.length) {
        let params = {
          planId: this.currRow.planId,
          materials: details,
        }
        api
          .postApi('/material/detail/batch/save', params)
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success('保存成功')
              this.uploadMaterialModal = false
              this.currRow.status = 1
              this.uploadMLoading = false
            } else {
              this.$message.warning(res.data.msg)
              this.uploadMLoading = false
            }
          })
          .catch((err) => {
            console.log(err)
            this.uploadMLoading = false
          })
      } else {
        this.$message.warning('请上传素材')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.select-box {
  position: relative;
  .fold-btn {
    font-size: 14px;
    line-height: 20px;
    color: #1890ff;
    cursor: pointer;
    .rotate-icon {
      transition: 0.8s ease;
    }
    .rotate-up {
      transform: rotate(-180deg);
    }
  }
}
.filter-btn {
  min-width: 78px;
  width: auto;
  padding: 0 8px;
  margin-right: 8px;
  margin-bottom: 16px;
}
.filter-btn-primary {
  background: #1890ff;
  border-color: #1890ff;
  color: #ffffff;
}
.filter-btn-default {
  background: #f1f1f1;
  border-color: #f1f1f1;
  color: rgba(0, 0, 0, 0.65);
}
.media-list {
  position: relative;
  .table-wrap {
    padding-bottom: 80px;
  }
}

.create-plan {
  position: absolute;
  right: 24px;
  top: 50px;
  .save-btn {
    margin-right: 8px;
  }
}

#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}

.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}
/deep/.ant-table-thead > tr,
/deep/ .ant-table-tbody > tr {
  height: 54px;
}

/deep/ .ant-table-thead > tr > th,
/deep/ .ant-table-tbody > tr > td {
  padding: 0px 16px !important;
}
/deep/ .ant-table-thead > tr > th {
  padding: 0 16px;
}
#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

textarea.ant-input {
  width: 100%;
}

.ant-upload > div {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.left-btns > div {
  margin-bottom: 24px;
}

.img-mask {
  position: absolute;
  top: 20px;
  left: 21px;
}

.img-mask.video-mask {
  position: absolute;
  top: 182px;
  left: 21px;
}

.img-mask img {
  width: 100%;
  height: 100%;
}

.img-mask video,
.video-box video,
.upload-video video {
  width: 100%;
}

.upload-img,
.upload-video {
  width: 100%;
  padding: 0 17px;
  height: 160px;
}

.upload-img img,
.upload-video video {
  cursor: pointer;
}

/*上传物料*/
.material_warp {
  width: 100%;
  /*height: 600px;*/
  height: 495px;
  margin: 0 auto 24px;
  display: flex;

  .left_tags {
    width: 288px;
    padding: 8px;
    border-right: 1px solid rgba(233, 233, 233, 1);
    p {
      display: inline-block;
      background: rgba(0, 0, 0, 0.04);
      border-radius: 2px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      padding: 0 8px;
      color: rgba(0, 0, 0, 0.65);
      margin-right: 8px;
      margin-top: 8px;
    }
    p:last-child {
      margin-right: 0;
    }
    li {
      border-radius: 4px;
      padding: 12px;
      cursor: pointer;
      margin-bottom: 8px;
      position: relative;

      h4 {
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
      }

      .active_icon {
        position: absolute;
        right: 12px;
        top: 27px;

        svg {
          font-size: 18px;
          color: rgba(82, 196, 26, 1);
        }
      }
    }

    .active_tag {
      background: rgba(0, 0, 0, 0.05);
    }
  }

  .right_conten {
    flex: 1;

    header {
      height: 64px;
      border-bottom: 1px solid rgba(233, 233, 233, 1);
      line-height: 64px;
      text-align: center;

      .ant-form-item {
        margin-bottom: 0;
        height: 100%;

        .ant-form-item-label,
        .ant-form-item-control {
          line-height: 64px;
        }
      }
    }

    .material_upload_body {
      /*width: 264px;*/
      width: 100%;
      /*height: 500px;*/
      margin: 24px auto;
      /*padding-top: 22px;*/
      border-radius: 8px;
      /*margin-bottom: 32px;*/
      /*background: url("../../../public/images/fullMaterial.png") no-repeat;*/
      background-size: contain;

      /deep/ .ant-upload {
        float: unset;
        /*width: 84%;*/
        width: 240px;
        height: 358px;
        margin: 12px auto;
        /*border: 1px dashed rgba(0,0,0,0.25);*/
        border-radius: 0;
      }

      .m-updataing {
        .u-ant-upload-img {
          /*margin: 121px auto 0;*/
          width: 35px;
          height: 28px;
          font-size: 20px;

          i {
            color: #1890ff;

            svg {
              width: 37px;
              height: 30px;
            }
          }
        }

        .u-ant-upload-text {
          font-size: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          line-height: 22px;
        }

        .u-ant-upload-info {
          font-size: 12px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.43);
          line-height: 20px;
        }
      }

      .m-updataed {
        /*position: absolute;*/
        /*top: 0px;*/
        /*left: 21px;*/
        width: 244px;
        margin: 0 auto;
        .m-bg-img {
          /*width: 222px;*/
          /*height: 334px;*/
          width: 240px;
          /*cursor: pointer;*/
          margin: 0 auto;
          img {
            width: 100%;
            height: 100%;
          }

          video {
            width: 100%;
            height: 100%;
            cursor: pointer;
          }
        }

        .m-img-info {
          position: absolute;
          top: 0px;
          width: 240px;
          /*width: 222px;*/
          /*height: 334px;*/

          .u-ant-upload-img {
            position: relative;
            margin: 0px auto 12px;
            padding-top: 121px;
            width: 35px;
            height: 28px;
            font-size: 20px;
            box-sizing: content-box;

            i {
              position: absolute;

              &:first-child {
                color: #1890ff;

                svg {
                  width: 37px;
                  height: 30px;
                }
              }

              &:last-child {
                bottom: -2px;
                right: -2px;
                color: #52c41a;

                svg {
                  width: 14px;
                  height: 14px;
                }
              }
            }
          }

          .u-ant-upload-text {
            font-size: 14px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
            text-align: center;
            margin-bottom: 10px;
          }

          .u-ant-upload-info {
            font-size: 12px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.43);
            line-height: 20px;
            text-align: center;
          }

          .u-clost-updata {
            position: absolute;
            top: -10px;
            right: -10px;
            width: 20px;
            height: 20px;
            cursor: pointer;
            color: #de2c2c;

            svg {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
.new_right {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
</style>